// removed by extract-text-webpack-plugin
module.exports = {"box":"_3L3Nb3ph3UfTkkIhtcXe01","input":"_2iBxECc71RaE9t2INW8KXj"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Mobile/Common/Booking/GroupInput.scss
// module id = 1107
// module chunks = 0